// 会话过期事件总线：401 拦截器在跳转登录前触发，各表单组件可监听并缓存数据

type Listener = () => void;
const listeners = new Set<Listener>();

/** 注册会话过期监听器，返回取消注册函数 */
export function onSessionExpired(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** 触发会话过期事件（由 401 拦截器调用） */
export function emitSessionExpired(): void {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* 忽略监听器错误 */
    }
  });
}

// ── 登出事件总线：401 拦截器清除 token 时触发，AuthContext 监听并同步状态 ──

type LogoutListener = () => void;
const logoutListeners = new Set<LogoutListener>();

/** 注册登出监听器，返回取消注册函数 */
export function onForceLogout(fn: LogoutListener): () => void {
  logoutListeners.add(fn);
  return () => logoutListeners.delete(fn);
}

/** 触发登出事件（由 401 拦截器调用，在清除 localStorage token 后） */
export function emitForceLogout(): void {
  logoutListeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* 忽略监听器错误 */
    }
  });
}

/** 安全读取 localStorage（兼容隐私模式） */
export function safeGetItem(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}

/** 安全写入 localStorage（兼容隐私模式） */
export function safeSetItem(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch { /* ignore */ }
}

/** 安全删除 localStorage（兼容隐私模式） */
export function safeRemoveItem(key: string): void {
  try { localStorage.removeItem(key); } catch { /* ignore */ }
}
